"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});

var _Table = _interopRequireDefault(require("./Table"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Table/index.js
// module id = 815
// module chunks = 0